import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    title: "Ayúdanos a mejorar",
    body: "Con tu permiso, usaremos datos de uso anónimos para entregarte una mejor experiencia.",
    more: "Más información",
    accept: "Aceptar",
    reject: "Rechazar",
  },
  en: {
    title: "Help us improve",
    body: "With your permission, we'll use anonymous usage data to give you a better experience.",
    more: "Learn more",
    accept: "Accept",
    reject: "Reject",
  },
});
